import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import style from './ReviewCard.module.sass'

export const LoaderProductReview: FunctionComponent = () => {
	return (
		<div className={style.root}>
			<div className={style.header}>
				<div className={style.scoreWrapper}>
					<div className={clsx(style.loading, style.loadingTitle)} />
				</div>
				<div className={style.date}>
					<div className={clsx(style.loading, style.loadingDate)} />
				</div>
			</div>
			<div className={style.text}>
				<div className={clsx(style.loading, style.loadingText)} />
				<div className={clsx(style.loading, style.loadingText)} />
				<div className={clsx(style.loading, style.loadingText)} />
				<div className={clsx(style.loading, style.loadingText)} />
			</div>
			<div className={style.foot}>
				<div className={style.meta}>
					<div className={clsx(style.loading, style.loadingIcon)} />
					<div className={clsx(style.loading, style.loadingName)} />
					<div className={style.metaInfo}>
						<div className={style.metaName}>
							<div className={clsx(style.loading, style.loadingAdditional)} />
						</div>
					</div>
				</div>
				<div className={clsx(style.loading, style.loadingRating)} />
			</div>
		</div>
	)
}
